import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface ReviewImageState {
    state: LoadStateInfo;
    request?: ReviewImageRequest;
}

const initialState: ReviewImageState = {
    state: notStarted(),
};

export interface ReviewImageRequest {
    status: number;
    imageIds: string[];
}

export const performaImageReview = createAsyncThunk(
    "performaImageReview",
    async (params: ReviewImageRequest, thunkAPI) => {
        console.debug("performaImageReview");

        const response = await fetch(`${getBackendUrl()}/api/image/review`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(params),
        });

        if (response.ok) {
            return "OK";
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    }
);


export const imagesSlice = createSlice({
    name: "imagesSlice",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(performaImageReview.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
            })
            .addCase(performaImageReview.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
            })
            .addCase(performaImageReview.rejected, (state, action) => {
                state.state = error(action);
            });
    },
});

// export const { } = imagesSlice.actions;

export const selectImageReview = (state: RootState) => state.imageReview;

export default imagesSlice.reducer;
